import React from 'react';
import Header from '../../Components/Header_Admin';

const Admin_Dashboard = () => {
  return (
    <>
      <Header />

      <div className="container-fluid py-4 bg-light" style={{ minHeight: '90vh' }}>
        
        {/* Page Title */}
        <div className="text-center mb-5">
          <h2 className="fw-bold text-dark">Admin Dashboard</h2>
          <p className="text-muted">Welcome to your control panel</p>
        </div>

        {/* Dashboard Cards */}
        <div className="row g-4 px-3">

          {/* Card 1 */}
          <div className="col-12 col-sm-6 col-lg-3">
            <div className="card border-0 shadow-sm rounded-4 h-100">
              <div className="card-body text-center">
                <div className="mb-3">
                  <i className="bi bi-people-fill fs-1 text-primary"></i>
                </div>
                <h5 className="fw-semibold">Users</h5>
                <h3 className="fw-bold">1,245</h3>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-12 col-sm-6 col-lg-3">
            <div className="card border-0 shadow-sm rounded-4 h-100">
              <div className="card-body text-center">
                <div className="mb-3">
                  <i className="bi bi-cash-stack fs-1 text-success"></i>
                </div>
                <h5 className="fw-semibold">Revenue</h5>
                <h3 className="fw-bold">Rs. 85K</h3>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-12 col-sm-6 col-lg-3">
            <div className="card border-0 shadow-sm rounded-4 h-100">
              <div className="card-body text-center">
                <div className="mb-3">
                  <i className="bi bi-box-seam fs-1 text-warning"></i>
                </div>
                <h5 className="fw-semibold">Packages</h5>
                <h3 className="fw-bold">32</h3>
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="col-12 col-sm-6 col-lg-3">
            <div className="card border-0 shadow-sm rounded-4 h-100">
              <div className="card-body text-center">
                <div className="mb-3">
                  <i className="bi bi-graph-up-arrow fs-1 text-danger"></i>
                </div>
                <h5 className="fw-semibold">Growth</h5>
                <h3 className="fw-bold">+12%</h3>
              </div>
            </div>
          </div>

        </div>

      </div>
    </>
  );
};

export default Admin_Dashboard;